import { render, staticRenderFns } from "./InquiryModule.vue?vue&type=template&id=511ebeb1&"
import script from "./InquiryModule.vue?vue&type=script&lang=js&"
export * from "./InquiryModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports